import { useState, useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Passcode from "@/components/Passcode";
import Dashboard from "@/components/Dashboard";

function App() {
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    setAuthed(localStorage.getItem("aks_authed") === "true");
  }, []);

  const handleLogin = () => {
    localStorage.setItem("aks_authed", "true");
    setAuthed(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("aks_authed");
    setAuthed(false);
  };

  return (
    <div className="App">
      {authed ? (
        <Dashboard onLogout={handleLogout} />
      ) : (
        <Passcode onLogin={handleLogin} />
      )}
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
